import { ElMessage, ElMessageBox } from 'element-plus'

/**
 * 危险操作：先确认说明，再要求输入当前用户登录密码。
 * @returns {Promise<string>} operation_password
 */
export async function confirmDangerousOperation({
  message,
  title = '危险操作确认',
  confirmButtonText = '继续',
  html = false,
}) {
  await ElMessageBox.confirm(message, title, {
    type: 'warning',
    confirmButtonText,
    cancelButtonText: '取消',
    confirmButtonClass: 'el-button--danger',
    dangerouslyUseHTMLString: html,
  })

  const { value } = await ElMessageBox.prompt(
    '请输入您的登录密码以确认此操作（防止误触）：',
    '操作密码验证',
    {
      confirmButtonText: '确认执行',
      cancelButtonText: '取消',
      inputType: 'password',
      inputPlaceholder: '登录密码',
      showClose: false,
    }
  )

  const password = (value || '').trim()
  if (!password) {
    ElMessage.warning('未输入密码，操作已取消')
    throw 'cancel'
  }
  return password
}

/**
 * 危险操作：确认后依次输入账号、登录密码（用于结束盘点轮次等）。
 * @returns {Promise<{ username: string, password: string }>}
 */
export async function confirmDangerousOperationWithAccount({
  message,
  title = '危险操作确认',
  confirmButtonText = '继续',
  expectedUsername = '',
  html = false,
}) {
  await ElMessageBox.confirm(message, title, {
    type: 'warning',
    confirmButtonText,
    cancelButtonText: '取消',
    confirmButtonClass: 'el-button--danger',
    dangerouslyUseHTMLString: html,
  })

  const { value: usernameRaw } = await ElMessageBox.prompt(
    expectedUsername
      ? `请输入管理员账号（当前登录：${expectedUsername}）以确认：`
      : '请输入管理员账号以确认：',
    '账号确认',
    {
      confirmButtonText: '下一步',
      cancelButtonText: '取消',
      inputPlaceholder: '登录账号',
      inputValue: '',
      showClose: false,
    }
  )
  const username = (usernameRaw || '').trim()
  if (!username) {
    ElMessage.warning('未输入账号，操作已取消')
    throw 'cancel'
  }
  if (expectedUsername && username !== expectedUsername) {
    ElMessage.error('账号与当前登录管理员不一致')
    throw 'cancel'
  }

  const { value: passwordRaw } = await ElMessageBox.prompt(
    '请输入登录密码以确认此操作：',
    '密码确认',
    {
      confirmButtonText: '确认执行',
      cancelButtonText: '取消',
      inputType: 'password',
      inputPlaceholder: '登录密码',
      showClose: false,
    }
  )
  const password = (passwordRaw || '').trim()
  if (!password) {
    ElMessage.warning('未输入密码，操作已取消')
    throw 'cancel'
  }
  return { username, password }
}
